module.exports = __webpack_public_path__ + "static/media/widget.180f8885.png";